import React from "react";

function DeleteConfirmationModal({ type, item, onConfirm, onClose, loading }) {
  const isCategory = type === "category";
  const hasSubcategories = isCategory && item?.subCategories?.length > 0;
  const itemName = isCategory ? item?.categoryName : item?.subCategoryName;

  return (
    <div className="cs-modal-overlay" onClick={loading ? undefined : onClose}>
      <div
        className="category-settings-modal category-settings-delete-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="category-settings-modal-title">
          Delete {isCategory ? "Category" : "Subcategory"}?
        </div>
        <div className="category-settings-delete-text">
          Are you sure you want to delete "{itemName}"?
        </div>
        {hasSubcategories ? (
          <div className="category-settings-warning">
            Deleting this category will also delete all of its subcategories.
          </div>
        ) : null}
        <div className="category-settings-modal-actions">
          <button
            className="cs-btn category-settings-danger-btn"
            type="button"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
          <button
            className="cs-btn cs-btn-outline"
            type="button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;
